<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useAgentFindings } from '../../composables/useAgentFindings'
import { useAuth } from '../../composables/useAuth'
import { useViewAs } from '../../composables/useViewAs'
import AgentFindingsCard from './AgentFindingsCard.vue'
import EventLog from '../EventLog.vue'

// DevOps tab (spec 2026-10-02). The agents run ~06:00 UK on weekdays; a 15-min
// re-fetch picks the new verdicts up without a reload (server caches 5 min).
// Since 2026-10-03 the poll is shared with the Dashboard's P/S pills
// (useAgentFindings): opening the tab joins the poll and refreshes once.
const { agents, error, start, stop, load } = useAgentFindings()

// Acknowledge controls (Paolo 2026-10-16): superuser acting as themselves — the
// same rule the server applies (403 otherwise).
const { isSuperUser } = useAuth()
const { target: viewAsTarget } = useViewAs()
const canAck = computed(() => isSuperUser.value && viewAsTarget.value === null)

onMounted(() => {
  const created = start()
  if (!created) void load()
})

onUnmounted(() => stop())
</script>

<template>
  <div class="devops-panel" data-testid="devops-panel">
    <div v-if="error && !agents.length" class="card muted" data-testid="devops-error">
      Agent findings unavailable — could not reach the server.
    </div>
    <AgentFindingsCard v-for="a in agents" :key="a.agent" :findings="a" :can-ack="canAck" />
    <EventLog />
  </div>
</template>

<style scoped>
.devops-panel { display: flex; flex-direction: column; gap: 1rem; }
.muted { color: #9e9e9e; }
</style>
